import CircularProgress from '@material-ui/core/CircularProgress';
import { FooterEbook } from '@orientaction/components';
import { LayoutResultat } from '@orientaction/layouts';
import { ReactNode } from 'react';
import EbookReaderHeader from './EbookReaderHeader';
import FloatingEbookActions from './FloatingEbookActions';
import { useEbookReaderLayoutStyles } from './EbookReaderLayout.styles';

type EbookReaderLayoutProps = {
  loading: boolean;
  readOnly: boolean;
  index?: number;
  toBack: string;
  ebookName: string;
  summaryHref?: string;
  showFooter?: boolean;
  children: (readOnly: boolean) => ReactNode;
};

const EbookReaderLayout = ({
  loading,
  readOnly,
  index,
  toBack,
  ebookName,
  summaryHref = 'page-6',
  showFooter = true,
  children,
}: EbookReaderLayoutProps) => {
  const classes = useEbookReaderLayoutStyles();

  return (
    <LayoutResultat isWhite={true} showLogo={false} toBack={toBack} index={index} hideHeader={true}>
      <EbookReaderHeader index={index} toBack={toBack} />
      <main className={classes.page}>
        {loading ? (
          <div className={classes.loadingCenter}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <div className={classes.ebookContent}>
              {children(readOnly)}
            </div>

            {showFooter && (
              <div className={classes.footerWrap}>
                <FooterEbook ebookName={ebookName} toBack={toBack} />
              </div>
            )}

            <FloatingEbookActions summaryHref={summaryHref} />
          </>
        )}
      </main>
    </LayoutResultat>
  );
};

export default EbookReaderLayout;
